import { __awaiter, __generator } from "tslib";
import { HttpClient } from '@wix/http-client';
var getSettingsUrl = function (locationId) {
    return "https://manage.wix.com/_api/restaurants/v2.1/settings" + (locationId ? "?locationId=" + locationId : '');
};
export function getOrganizationFull(organizationId) {
    return __awaiter(this, void 0, void 0, function () {
        var httpClient, response, _a, restaurant, menu;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    httpClient = new HttpClient();
                    return [4 /*yield*/, httpClient.get("https://api.wixrestaurants.com/v2/organizations/" + organizationId + "/full")];
                case 1:
                    response = _b.sent();
                    _a = response.data, restaurant = _a.restaurant, menu = _a.menu;
                    return [2 /*return*/, {
                            restaurant: restaurant,
                            menu: menu,
                        }];
            }
        });
    });
}
export function getOrganizationAndMenu(signedInstance, locationId, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var url, data, response, _a, restaurant, menu, locations;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "https://apps.wixrestaurants.com/organization/get?instance=" + signedInstance +
                        (locationId ? "&locationId=" + locationId : "");
                    if (!(typeof fetch !== 'undefined')) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch(url).then(function (response) { return response.json(); })];
                case 1:
                    data = _b.sent();
                    if (!data.value) {
                        return [2 /*return*/, null];
                    }
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, httpClient.get(url)];
                case 3:
                    response = _b.sent();
                    if (response.status !== 200 || !response.data.value) {
                        return [2 /*return*/, null];
                    }
                    data = response.data;
                    _b.label = 4;
                case 4:
                    _a = data.value, restaurant = _a.restaurant, menu = _a.menu, locations = _a.locations;
                    return [2 /*return*/, {
                            restaurant: restaurant,
                            menu: menu,
                            locations: locations || [],
                            fromSite: data.fromSite,
                        }];
            }
        });
    });
}
export function getOrganizationFullByMsid(msid, baseUrl, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, restaurant, menu;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, httpClient.get(baseUrl + "/_serverless/restaurants-organization-service-msid/v1/organization-full/" + msid)];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        _a = response.data, restaurant = _a.restaurant, menu = _a.menu;
                        return [2 /*return*/, {
                                restaurant: restaurant,
                                menu: menu,
                            }];
                    }
                    return [2 /*return*/, undefined];
            }
        });
    });
}
export function getOrganizationFullByMsidV2(msid, baseUrl, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, restaurant, menu;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, httpClient.get(baseUrl + "/_serverless/restaurants-organization-service-msid/v2/organization-full/" + msid)];
                case 1:
                    response = _b.sent();
                    if (response.status === 200) {
                        _a = response.data, restaurant = _a.restaurant, menu = _a.menu;
                        return [2 /*return*/, {
                                restaurant: restaurant,
                                menu: menu,
                            }];
                    }
                    return [2 /*return*/, undefined];
            }
        });
    });
}
export function getOrganizationFullByAppDefAndInstance(instanceId, appId, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var response, value, restaurant, menu;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, httpClient.get("https://apps.wixrestaurants.com/organization/get/?instanceId=" + instanceId + "&appId=" + appId)];
                case 1:
                    response = _a.sent();
                    if (response.status === 200 && response.data.value) {
                        value = response.data.value;
                        restaurant = value.restaurant, menu = value.menu;
                        return [2 /*return*/, {
                                restaurant: restaurant,
                                menu: menu,
                            }];
                    }
                    return [2 /*return*/, undefined];
            }
        });
    });
}
export function getSettings(signedInstance, locationId, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var settings;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, httpClient
                        .get(getSettingsUrl(locationId), {
                        headers: {
                            Authorization: signedInstance,
                        },
                    })
                        .then(function (r) { return r.data; })];
                case 1:
                    settings = (_a.sent()).settings;
                    return [2 /*return*/, settings];
            }
        });
    });
}
//# sourceMappingURL=organization.js.map